import { styled, Popper as MuiPopper } from '@mui/material';
export var StyledPopper = styled(MuiPopper, {
    shouldForwardProp: function (prop) { return ![''].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme;
    return ({});
});
//# sourceMappingURL=styled.js.map